import { AODA } from "@core/utilities/aoda";
import {
  Component,
  ElementRef,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from "@angular/core";
import { BaseComponent } from "@shared/components/base.component";
import { FormGroup } from "@angular/forms";
import { startWith, map } from "rxjs/operators";

@Component({
  selector: "app-year-filter",
  templateUrl: "./year-filter.component.html",
  styleUrls: ["./year-filter.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class YearFilter extends BaseComponent implements OnInit, OnDestroy {

  @Input() f: FormGroup;
  @Input() clearFilter: boolean;
  @Input() enableFilter: boolean;
  displayYearFilter: boolean = false;
  lastFilter = "";
  fromYears: string[] = [];
  toYears: string[] = [];
  tempFromYears: string[] = [];
  tempToYears: string[] = [];
  filteredFromYears: string[];
  filteredToYears: string[];

  constructor(
    private injector: Injector,
    private el: ElementRef,
    private r2: Renderer2,
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initYears();

    if(this.f.get("yearFrom").value || this.f.get("yearTo").value) {
      this.displayYearFilter = true;
    } else {
      this.displayYearFilter = false;
    }

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
  }

  ngOnChanges() {
    if(this.clearFilter) {
      this.initYears();
      this.clearFilter = false;
    }

    if(!this.enableFilter) {
      this.displayYearFilter = false;
    }

    this.yearFrom.valueChanges
    .pipe(
      startWith<string | any[]>(""),
      map((value) => (typeof value === "string" ? value : this.lastFilter)),
      map((filter) => this.filterFromYear(filter))
    )
    .subscribe((data) => (this.filteredFromYears = data));

  this.yearTo.valueChanges
    .pipe(
      startWith<string | any[]>(""),
      map((value) => (typeof value === "string" ? value : this.lastFilter)),
      map((filter) => this.filterToYear(filter))
    )
    .subscribe((data) => (this.filteredToYears = data));
  }

  initYears() {
    for (var year = 1800; year <= new Date().getFullYear(); year++) {
      this.fromYears.push(year.toString());
      this.toYears.push(year.toString());
    }

    this.filteredFromYears = this.tempFromYears = this.fromYears;
    this.filteredToYears = this.tempToYears = this.toYears;
  }

  //Filter Functions
  onDisplayYearFilter() {
    if(this.enableFilter) {
      this.displayYearFilter = !this.displayYearFilter;
    }
  }

  filterFromYear(year: string): any[] {

    this.updateFromYears();
    this.updateToYears();

    if (year) {
      return this.tempFromYears.filter((option) => {
        return option.startsWith(year);
      });
    } else {
      //need to reset the toYears when no value is present
      this.filteredToYears = this.tempToYears = this.toYears;
      return this.tempFromYears.slice();
    }
  }

  filterToYear(year: string): any[] {

    this.updateToYears();
    this.updateFromYears;

    if (year) {
      return this.tempToYears.filter((option) => {
        return option.startsWith(year);
      });
    } else {
      return this.tempToYears.slice();
    }
  }
  //Filter Functions

  updateToYears() {
    if(this.toYears.includes(this.yearFrom.value)) {
      this.tempToYears = [];
      for(var year = Number(this.yearFrom.value); year <= new Date().getFullYear(); year++) {
        this.tempToYears.push(year.toString());
      }
      this.filteredToYears = this.tempToYears;
    } else {
      this.tempToYears = this.toYears;
    }
  }

  updateFromYears() {
    var startingYear = this.yearFrom.value && this.yearFrom.value > 1800 ? Number(this.yearFrom.value) : 1800;
    if(this.fromYears.includes(this.yearTo.value)) {
      this.tempFromYears = [];
      for(var year = startingYear; year <= Number(this.yearTo.value); year++) {
        this.tempFromYears.push(year.toString());
      }
      this.filteredFromYears = this.tempFromYears;
    } else {
      this.tempFromYears = this.fromYears;
    }
  }

  get yearFrom() {
    return this.f.get("yearFrom");
  }

  get yearTo() {
    return this.f.get("yearTo");
  }
}
